import { useState } from 'react';

export interface SchedulingNoteDraft { value: string; saved: string }

export function SchedulingNoteCell({ draft, disabled, pronumber, onSave, onDrag, onError }: {
  draft: SchedulingNoteDraft;
  disabled: boolean;
  pronumber: number;
  onSave: (note: string) => Promise<void>;
  onDrag: (note: string) => void;
  onError: () => void;
}) {
  const [value, setValue] = useState(draft.value);
  const [saving, setSaving] = useState(false);
  const save = async () => {
    const note = value.trim();
    if (!note || note === draft.saved || saving) return;
    setSaving(true);
    try { await onSave(note); draft.saved = note; }
    catch { onError(); }
    finally { setSaving(false); }
  };
  return <div className="relative group" onClick={event => event.stopPropagation()}>
    <textarea
      aria-label={`Scheduling note for PRO ${pronumber}`}
      placeholder="Add note…"
      rows={1}
      disabled={disabled || saving}
      className="w-full min-w-40 rounded border border-gray-300 bg-transparent px-2 py-1 text-sm disabled:opacity-50"
      value={value}
      onChange={event => { draft.value = event.target.value; setValue(event.target.value); }}
      onBlur={save}
    />
    {value.trim() && !disabled && !saving && <button
      type="button"
      aria-label="Drag to copy scheduling note"
      title="Drag down to copy this note to other PROs"
      className="absolute bottom-0 right-0 w-3 h-3 bg-blue-500 cursor-crosshair opacity-0 group-hover:opacity-100 focus:opacity-100 rounded-sm"
      onMouseDown={event => { event.preventDefault(); event.stopPropagation(); void save(); onDrag(value.trim()); }}
    />}
  </div>;
}
